<template lang="pug">
v-container
  div.text-lg.font-medium.basic700--text {{ $t('search_engine_optimization') }}
  div.text-sm.font-normal.basic600--text {{ $t('search_engine_optimization_desc') }}

  v-row.mt-6(no-gutters)
    v-col(cols="12" sm="6")
      div.text-md.font-medium.basic700--text {{ $t('seo_title') }}
      div.text-md.font-normal.basic600--text {{ $t('seo_title_desc') }}
      v-text-field.text-md.font-normal.round-xl.mt-4(v-model="title" :placeholder="$t('seo_title')" outlined)

  div.text-md.font-medium.basic700--text {{ $t('seo_description') }}
  div.text-md.font-normal.basic600--text {{ $t('seo_description_desc') }}
  v-textarea.text-md.font-normal.round-xl.mt-4(v-model="description" :placeholder="$t('seo_description')" outlined)

  div.text-md.font-medium.basic700--text {{ $t('seo_photo') }}
  div.text-md.font-normal.basic600--text {{ $t('seo_photo_desc') }}
  v-row.mt-4(no-gutters align="center" v-if="resizeImageFileUrl")
    v-col(cols="12" sm="6")
      v-card(flat)
        div(align="center")
          v-img(:src="resizeImageFileUrl" contain width="240")
            template(v-slot:placeholder)
              v-row(class="fill-height ma-0" align="center" justify="center")
                v-progress-circular(indeterminate color="grey")
    v-col(cols="12" sm="6" :align="isMobileScreen ? 'center' : ''")
      div.file-change-layout.ml-4
        v-btn.round-lg.text-md.font-bold.text-none.pl-5.pr-4.py-3(color="basic700" outlined depressed height="48")
          v-icon(left color="basic700") mdi-image-outline
          | {{ $t('change_image') }}
        input.input-change-layout(type="file" @change="onFileChange" accept="image/*" style="width: 157px !important")
  div.round-3xl.file-layout.py-8.mt-4(v-else align="center")
    div.text-md.font-normal.info500--text
      v-icon.mb-1(color="info500" left size="22") $yzi-upload-01
      | {{ $t('upload_photo_10_mb') }}
    input.input-layout(type="file" @change="onFileChange" accept="image/*")

  div.d-flex.my-8
    v-spacer
    v-btn.button-md(color="primary" dark depressed :loading="isLoading" @click="saveData") {{ $t('save') }}
  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { resizeImage } from '@/utils'

export default {
  name: 'SharingSeo',
  data () {
    return {
      isLoading: false,
      title: null,
      description: null,
      resizeImageFileUrl: '',
      resizeImageFile: null,
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      clinic: 'clinic/getClinic'
    }),
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    }
  },
  mounted () {
    if (this.clinic) {
      this.setData(this.clinic)
    }
  },
  methods: {
    ...mapActions(['showMessage']),
     async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      const resizedImage = await resizeImage(files[0], 'product_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    },
    setData (clinic) {
      if (clinic.meta_image) {
        this.resizeImageFileUrl = clinic.meta_image.file
      }
      this.title = clinic.meta_title
      this.description = clinic.meta_description
    },
    saveData () {
      this.isLoading = true
      var params = new FormData()
      if (this.title) {
        params.set('meta_title', this.title)
      }
      if (this.description) {
        params.set('meta_description', this.description)
      }
      if (this.resizeImageFile) {
        params.append('meta_image', this.resizeImageFile)
      }
      this.$axios.patch(`/clinics/${this.company.slug}`, params)
        .then(resp => {
          this.setData(resp.data)
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.file-layout {
  position: relative;
  cursor: pointer;
  border: var(--v-basic500) dashed 2px;
}
.input-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
  cursor: pointer;
}
.file-change-layout {
  position: relative;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>